/**
 * employe.js
 */

// Import
import "./employe.scss";
import $ from 'jquery';

$(document).ready(function() {

});

